(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFileTypesDialogController', TabFileTypesDialogController);

    TabFileTypesDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'TabFileTypes', '$state'];

    function TabFileTypesDialogController ($timeout, $scope, $stateParams, entity, TabFileTypes, $state) {
        var vm = this;
        vm.tabFileTypes = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabFileTypesUpdate', result);
            vm.isSaving = false;
            $state.go('tab-file-types');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabFileTypes.id !== null) {
                TabFileTypes.update(vm.tabFileTypes, onSaveSuccess, onSaveError);
            } else {
                TabFileTypes.save(vm.tabFileTypes, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $state.go('tab-file-types');
        };
    }
})();
